export const newRelic = (to, from, next) => {
  if (window.newrelic !== undefined) {
    let i = window.newrelic.interaction();
    i.setName(to.fullPath);
    i.setAttribute({ from: from.fullPath });
    i.save();
  }
  return next();
};
